import React, { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ShapeRenderer from "./ShapeRenderer";
import { resolveState } from "../defaults";
import { ensureShapeFont } from "../fonts";

// Measures the box (layout size, so editor zoom transforms don't count) and
// redraws the shape in pixel space whenever the box is resized.
export default function MeasuredShape({ state }) {
  const ref = useRef(null);
  const [size, setSize] = useState({ w: 0, h: 0 });
  const resolved = resolveState(state);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const w = el.offsetWidth;
      const h = el.offsetHeight;
      setSize((prev) => (prev.w === w && prev.h === h ? prev : { w, h }));
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const font = resolved.text.font;
  useLayoutEffect(() => {
    if (font) ensureShapeFont(font);
  }, [font]);

  return (
    <div ref={ref} className="vector-shape-host" style={{ width: "100%", height: "100%" }}>
      <ShapeRenderer state={resolved} width={size.w || 100} height={size.h || 100} />
    </div>
  );
}

MeasuredShape.propTypes = {
  state: PropTypes.object,
};
